import { useMatcapTexture, Center, Text3D, OrbitControls, Scroll, ScrollControls, useScroll } from '@react-three/drei'
// import { Perf } from 'r3f-perf'
import { useEffect, useRef, useState } from 'react'
// import { useFrame } from '@react-three/fiber'
import {Float} from "@react-three/drei";
import { AnimatedText } from './AnimatedText.tsx'
import * as THREE from 'three'
import Media from 'react-media';


const material = new THREE.MeshMatcapMaterial()

export default function Experience()
{
    // const AnimatedText = useRef();
    const FADE_INTERVAL_MS = 550
    const WORD_CHANGE_INTERVAL_MS = FADE_INTERVAL_MS * 2
    const WORDS_TO_ANIMATE  = ['Hello', 'Ciao', 'Jambo', 'Bonjour', 'Salut', 'Hola', 'Buenas', 'Hallo', 'Hej', 'やあ!']
    // const WORDS_TO_ANIMATE  = ['Hola', 'Lis', 'Buenas','Te Amo']



    type FadeProp = { fade: 'fade-in' | 'fade-out' }

    const [fadeProp, setFadeProp] = useState<FadeProp>({ fade: 'fade-in' })
    const [wordOrder, setWordOrder] = useState(0)
  

    const [ matcapTexture ] = useMatcapTexture("0F0F0F_4B4B4B_1C1C1C_2C2C2C", 64);

    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
      });

      const ref = useRef();


      function debounce(fn, ms) {
        let timer;
        return (_) => {
          clearTimeout(timer);
          timer = setTimeout((_) => {
            timer = null;
            fn.apply(this, arguments);
          }, ms);
        };
      }
      
    

    useEffect(() => {
        const fadeTimeout = setInterval(() => {
        fadeProp.fade === 'fade-in' ? setFadeProp({ fade: 'fade-out' }) : setFadeProp({ fade: 'fade-in' })
        }, FADE_INTERVAL_MS)

        return () => clearInterval(fadeTimeout)
    }, [fadeProp])

    useEffect(() => {
        const wordTimeout = setInterval(() => {
        setWordOrder((prevWordOrder) => (prevWordOrder + 1) % WORDS_TO_ANIMATE.length)
        }, WORD_CHANGE_INTERVAL_MS)

        return () => clearInterval(wordTimeout)
    }, [])


    useEffect(() =>
    {
        matcapTexture.encoding = THREE.sRGBEncoding
        matcapTexture.needsUpdate = true

        material.matcap = matcapTexture
        material.needsUpdate = true
    }, [])



    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
          setDimensions({
            height: window.innerHeight,
            width: window.innerWidth,
          });
        }, 3);
    
        window.addEventListener("resize", debouncedHandleResize);
    
        return (_) => {
          window.removeEventListener("resize", debouncedHandleResize);
        };
      }, []);
















    return <>
        {/* <AnimatedText ref={AnimatedText}/> */}
        {/* <Perf position="top-left" /> */}

        {/* <OrbitControls makeDefault enabled={false} /> */}
        {/* <Canvas> */}
        {/* <ScrollControls damping={4} pages={3} distance={1.5}>
        <Scroll > */}
              {/* {console.log("Scroll component rendered")} */}
              {/* <Canvas style={{ height: "500px", width: "800px" }}> */}

      
        <Center position={[0, 0, -6]}>
  


            <mesh>
            <Text3D
                material={ material }
                font="./fonts/mplusbold.json"
                // size={(dimensions.width * 1) / 1600}
                size={ 0.7 }
                // height={ 0.01 }
                // size={ viewport.width / 2}
                curveSegments={ 12 }
                bevelEnabled
                bevelThickness={ 0.02 }
                letterSpacing={-0.016}
                bevelSize={ 0.02 }
                bevelOffset={ 0 }
                bevelSegments={ 5 }
                >
            {/* {fadeProp.fade} */}
            {WORDS_TO_ANIMATE[wordOrder]}
             </Text3D>
             </mesh>


             {/* </Float> */}
        </Center>
    



                    {/* </Scroll> */}
             {/* </ScrollControls> */}
        {/* </Canvas> */}

    

    </>
}